export const UPDATE_EVENTS_DATA = '@@eventSearch/updateEvents';
export const UPDATE_EVENTS_FILTERS = '@@eventSearch/updateEventsFilters';
export const UPDATE_PANEL_EVENTS_FILTERS = '@@eventSearch/updatePanelEventsFilters';
export const SEARCH_RESULTS_UPDATE_EVENTS_PAGE = '@@eventSearchResult/updateEventsPage';
export const SEARCH_RESULTS_GET_ASSET_BY_EVENT = '@@eventSearchResult/getAssetsByEvents';
export const SEARCH_RESULTS_GET_EVENTS_BY_HAPPENING = '@@eventSearchResult/getEventsByHappening';
export const SEARCH_RESULTS_GET_EVENTS_BY_HAPPENING_SUCCESS = '@@eventSearchResult/getEventsByHappeningSuccess';
export const SEARCH_RESULTS_INIT_PANEL_EVENT_SEARCH = '@@eventSearchResult/initPanelEventSearch';
